import { createFileRoute } from '@tanstack/react-router';
import { VacationTestPage } from '@/features/vacation/pages/vacation-test-page';

export const Route = createFileRoute('/_app/vacation-test')({ component: VacationTestPage });
